import toDate from '../to-date';

export const isFutureDate = (date: Date | number): boolean => {
  return toDate(date).getTime() > Date.now();
};

export default isFutureDate;
